import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Learn from "@/pages/Learn";
import Article from "@/pages/Article";
import Topic from "@/pages/Topic";
import Resources from "@/pages/Resources";
import ResourceDetail from "@/pages/ResourceDetail";
import Faqs from "@/pages/Faqs";
import About from "@/pages/About";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Links from "@/pages/Links";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/components/AdminLayout";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminArticles from "@/pages/admin/Articles";
import ArticleEditor from "@/pages/admin/ArticleEditor";
import AdminFaqs from "@/pages/admin/Faqs";
import FaqEditor from "@/pages/admin/FaqEditor";
import AdminResources from "@/pages/admin/Resources";
import ResourceEditor from "@/pages/admin/ResourceEditor";
import AnalyticsRouter from "@/components/AnalyticsRouter";

function PublicShell({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <BrowserRouter>
            <AnalyticsRouter />
            <Routes>
              {/* Public site */}
              <Route path="/" element={<PublicShell><Home /></PublicShell>} />
              <Route path="/learn" element={<PublicShell><Learn /></PublicShell>} />
              <Route path="/learn/:category" element={<PublicShell><Learn /></PublicShell>} />
              <Route path="/article/:slug" element={<PublicShell><Article /></PublicShell>} />
              <Route path="/topic/:slug" element={<PublicShell><Topic /></PublicShell>} />
              <Route path="/resources" element={<PublicShell><Resources /></PublicShell>} />
              <Route path="/resources/:slug" element={<PublicShell><ResourceDetail /></PublicShell>} />
              <Route path="/faqs" element={<PublicShell><Faqs /></PublicShell>} />
              <Route path="/checkout/success" element={<PublicShell><CheckoutSuccess /></PublicShell>} />

              {/* Standalone link-in-bio page (no site chrome) */}
              <Route path="/links" element={<Links />} />

              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="articles" element={<AdminArticles />} />
                <Route path="articles/new" element={<ArticleEditor />} />
                <Route path="articles/edit/:slug" element={<ArticleEditor />} />
                <Route path="faqs" element={<AdminFaqs />} />
                <Route path="faqs/new" element={<FaqEditor />} />
                <Route path="faqs/edit/:id" element={<FaqEditor />} />
                <Route path="resources" element={<AdminResources />} />
                <Route path="resources/new" element={<ResourceEditor />} />
                <Route path="resources/edit/:slug" element={<ResourceEditor />} />
              </Route>

              <Route path="*" element={<PublicShell><NotFound /></PublicShell>} />
            </Routes>
            <Toaster position="bottom-center" theme="light" toastOptions={{ style: { background: "var(--olive)", color: "var(--cream)", border: "none" } }} />
          </BrowserRouter>
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
